// @ts-nocheck
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import Multiclamp from 'react-multi-clamp';

import Text from 'crehana-ui/Text';

type LinkPreviewProps = {
  url: string;
  dark?: boolean;
  className?: string;
  showImageInMobile?: boolean;
};

type PreviewType = {
  title?: string;
  description?: string;
  url: string;
  image?: string;
};

const Image = styled.div`
  width: 90px;
  height: 72px;

  @media (min-width: 1024px) {
    width: 96px;
  }
`;

const LinkPreview: FC<LinkPreviewProps> = ({
  url,
  dark,
  className,
  showImageInMobile,
}) => {
  const [preview, setPreview] = useState<PreviewType | undefined>();

  useEffect(() => {
    fetch(`/api/link-preview/?q=${url}`)
      .then(res => res.json())
      .then(response => {
        setPreview(response);
      })
      .catch(error =>
        console.log("Link preview error. Preview won't be shown.", error),
      );
  }, [url]);

  if (preview && (preview.title || preview.description)) {
    return (
      <a
        href={preview.url}
        className={`${className} block ${
          dark ? 'bg-base-lighter-24' : 'bg-white'
        }`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <div
          className={`flex items-center mt-4 md:mt-16 ${
            dark ? '' : 'border border-solid border-gray-main'
          }`}
        >
          {preview.image && (
            <Image
              className={`${
                showImageInMobile ? '' : 'hidden md:block'
              } link-preview-image flex-shrink-0`}
              style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundImage: `url(${preview.image})`,
              }}
            />
          )}
          <div
            className={`flex flex-col items-start py-8 px-8 sm:px-16 text-left overflow-hidden${
              !dark ? ' bg-white' : ''
            }`}
          >
            {preview.title && (
              <Text
                className="mb-4"
                color={dark ? 'white' : 'base-main'}
                type="subtitle3"
                style={{ wordBreak: 'break-all' }}
              >
                <Multiclamp clamp={1}>{preview.title}</Multiclamp>
              </Text>
            )}
            {preview.description && (
              <Text color={dark ? 'white' : 'base-main'} type="legals">
                <Multiclamp clamp={2}>{preview.description}</Multiclamp>
              </Text>
            )}
          </div>
        </div>
      </a>
    );
  }
  return null;
};

export default LinkPreview;
